import userSettingsSlice from './userSettingsSlice';

export * from './types';

export const {
  populateUserSettings,
  setWindowSize,
  setJupyterHost,
  setQuickAccessDictionarySetting,
  setDashboardSidebarSetting,
  setExecutionHistorySidebarCollapsed,
  setDefaultSchemaId,
  setDefaultView,
  setActiveSchemaId,
  setSidebarState,
  setColorSchema,
} = userSettingsSlice.actions;

export default userSettingsSlice.reducer;
